/**
 * Get new capacity to be selected when current capacity is not available in the new selected color
 */
export const getNewSelectedCapacity = (availableSizes, currentCapacity): number => {
    let newCapacity: number;
    const minCapacity = Math.min(...availableSizes);
    const maxCapacity = Math.max(...availableSizes);

    switch (true) {
        case (availableSizes.indexOf(currentCapacity) !== -1):
            newCapacity = currentCapacity;
            break;
        case (currentCapacity > maxCapacity):
            newCapacity = maxCapacity;
            break;
        case (currentCapacity < minCapacity):
            newCapacity = minCapacity;
            break;
        default:
            // Get next bigger capacity
            newCapacity = availableSizes.filter(capacity => capacity > currentCapacity)[0];
            break;
    }

    return newCapacity;
};
